import React from 'react';
import { RegisterUserMutationVariables } from '../../API';
import { Typography } from '@mui/material';
import { formatDateOnly } from '../../dateUtils';

export function UsagePolicyGerman({
                                    currentData
                                  }: {
  currentData: Partial<RegisterUserMutationVariables>;
}) {
  return (
    <>
      {/*<Typography variant="overline">Usage Policy</Typography>*/}
      <Typography align="center">
        <b>Vereinbarung über Allgemeine Geschäftsbedingungen (AGB)</b>
        <br />
        <b>für die Nutzung der MIND.set-Plattform</b>
        <br /> <br />
        Zwischen den
        <br />
        <br />
        Deutsches Zentrum für Integrations- und Migrationsforschung (DeZIM) e.V.
        <br />
        Mauerstraße 76, 10117 Berlin, vertreten durch den Vorstand
        <br />- Nachstehend <b>"DeZIM"</b> genannt -<br />
        <br />
        und
        <br />
        <br />
        {currentData.name}
        <br />
        <br />- Nachfolgend als <b>"Nutzende”</b> bezeichnet -<br />
        <br />
        Nachfolgend gemeinsam als Parteien bezeichnet, wird die folgende
        Vereinbarung über die Einräumung von Nutzungsrechten und die
        Verarbeitung von Mikrodaten des DeZIM geschlossen:
      </Typography>
      <br />
      <Typography>
        <b>
          § 1 Vereinbarungsgegenstand und Geltungsbereich für die Nutzung der
          MIND.set-Plattform
        </b>
        <br />
        <br />
        (1) Diese AGB dienen der Festlegung der allgemeinen Rahmenbedingungen
        für das Rechtsverhältnis zwischen dem Deutschen Zentrum für
        Integrations- und Migrationsforschung DeZIM e.V. ("DeZIM") und den
        registrierten Nutzenden ("Nutzende") im Hinblick auf die unentgeltliche
        Zurverfügungstellung der onlinebasierten MIND.set-Plattform
        ("MIND.set-Plattform") und bilden die Grundlage für die Nutzung der auf
        der MIND.set-Plattform angebotenen Tools und Dienste, zu denen Zugang
        gewährt wird ("Dienste").
        <br />
        <br />
        Das DeZIM räumt den registrierten Nutzenden das Recht ein, die
        MIND.set-Plattform ausschließlich nach Maßgabe der nachfolgenden
        Vereinbarung zu nutzen.
        <br />
        <br />
        (2) Die Registrierung auf der MIND.set-Plattform und deren Nutzung
        unterliegt diesen Allgemeinen Bedingungen und Konditionen.
        <br />
        <br />
        (3) Diese Allgemeinen Bedingungen und Konditionen können jederzeit auf
        der MIND.set-Plattform abgerufen werden.
        <br />
        <br />
        (4) Das DeZIM behält sich das Recht vor, diese in einem für die
        Nutzenden zumutbaren Umfang zu ändern. Es gilt die jeweils neueste
        Fassung, es sei denn, der Nutzende widerspricht der Geltung der neuen
        Bestimmungen innerhalb von sechs (6) Wochen, nachdem das DeZIM ihn
        ausdrücklich auf diese und die Folgen seines Schweigens hingewiesen hat.
        <br />
        <br />
        (5) Soweit das DeZIM unentgeltliche Leistungen erbringt, sind diese
        nicht vertraglich zugesichert und können jederzeit und ohne vorherige
        Ankündigung geändert oder eingestellt werden. Das DeZIM behält sich
        daher auch das Recht vor, jederzeit Änderungen an der MIND.set-Plattform
        vorzunehmen oder abweichende Funktionen anzubieten, es sei denn, die
        Änderung oder Abweichung ist für das DeZIM und die Nutzende unter
        Berücksichtigung ihrer Interessen unzumutbar.
        <br />
        <br />
        <b>§ 2 Lizenz für wissenschaftliche Zwecke</b>
        <br />
        <br />
        (1) Die MIND.set-Plattform darf nur für die eigene wissenschaftliche
        Forschung der Nutzenden im Rahmen des folgenden Forschungsprojekts
        verarbeitet oder genutzt werden.
        <br />
        <br />
        Projektname: {currentData.researchProjectName}
        <br />
        <br />
        Projektstart: {formatDateOnly(currentData.projectStart)}
        <br />
        <br />
        Projektende: {formatDateOnly(currentData.projectEnd)}
        <br />
        <br />
        Beschreibung des Forschungsprojekts (kurze Beschreibung des
        Forschungsziels oder der zentralen Fragen des Projekts):
        <br />
        <pre style={{ marginLeft: '0.5em' }}>{currentData.researchGoal}</pre>
        <br />
        Beschreibung des methodischen Ansatzes (Forschungsmethoden):
        <br />
        <pre style={{ marginLeft: '0.5em' }}>
          {currentData.methodDescription}
        </pre>
        <br />
        Qualifizierungsprojekt:{' '}
        {currentData.isQualificationProject ? 'Ja' : 'Nein'}
        <br />
        <br />
        (2) Beschränkungen der Nutzung der Dienste:
        <br />
        <br />
        (2.1) Nicht-diskriminierende Grundsätze in MIND.set- Tests und auf der
        Plattform
        <br />
        <br />
        Tests und Inhalte auf der MIND.set-Plattform müssen sowohl sprachlich
        als auch konzeptionell den Grundsätzen der Nichtdiskriminierung genügen.
        Es gilt insbesondere Artikel 14 Diskriminierungsverbot Europäische
        Menschenrechtskonvention (EMRK):
        <br />
        <br />
        <i>
          „Der Genuss der in dieser Konvention festgelegten Rechte und
          Freiheiten ist ohne Diskriminierung, insbesondere aus Gründen des
          Geschlechts, der Rasse, der Hautfarbe, der Sprache, der Religion, der
          politischen oder sonstigen Anschauung, der nationalen oder sozialen
          Herkunft, der Zugehörigkeit zu einer nationalen Minderheit, des
          Vermögens, der Geburt oder eines sonstigen Status zu gewährleisten.“{' '}
        </i>
        <br />
        <br />
        Zudem müssen alle Materialien eine vorurteilsfreie Sprache und Bilder
        verwenden, die Inklusion und Respekt für alle Menschen gewährleisten und
        gleichzeitig vorurteilsbehaftete Überzeugungen oder erniedrigende
        Haltungen vermeiden.
        <br />
        <br />
        Unnötige und irrelevante Stereotypisierungen in Bezug auf Alter,
        Behinderung, Geschlecht, rassische und ethnische Identität, Religion,
        sexuelle Orientierung, sozioökonomischen Status und andere
        intersektionale Merkmale müssen vermieden werden. Die Nutzenden sind
        dafür verantwortlich, dass ihre Nutzung der Ressourcen der Plattform mit
        diesen Standards im Einklang steht.
        <br />
        <br />
        (2.2) Nutzung der MIND.set-Plattform und Tests
        <br />
        <br />
        Die MIND.set-Plattform und ihre Tests dürfen nur für wissenschaftliche
        Forschung, Experimente und Studien im Rahmen des angegebenen
        Forschungsprojekts verwendet werden. Die Tests dürfen den
        Studienteilnehmenden präsentiert werden, und einzelne Bilder oder
        Screenshots dürfen in Dokumentationen, Berichten oder wissenschaftlichen
        Publikationen (z. B. Konferenzpostern) mit der korrekten Quellenangabe
        aus dem jeweils aktuellen MIND.set{' '}
        <a href={'/impressum'} target={'_blank'}>
          Impressum
        </a>{' '}
        mit aktueller Software-Version verwendet werden:
        <br />
        <br />
        Die gemeinsame Nutzung von MIND.set-Accounts, die Weitergabe von Tests
        oder das Kopieren von Plattforminhalten an Externe in jeglicher Form ist
        nicht gestattet, unabhängig von Zweck oder Format. Die Nutzung der
        Plattform oder ihrer Tests für kommerzielle Zwecke ist strengstens
        untersagt.
        <br />
        <br />
        (2.3) Nutzung des MIND.set-Medienpools und der DeZIM-Fotodatenbanken
        <br />
        <br />
        Der MIND.set Medienpool enthält die DeZIM-Fotodatenbanken. Auch Fotos
        aus den DeZIM-Fotodatenbanken dürfen ausschließlich für
        wissenschaftliche Forschungen, Experimente und Studien im Rahmen des
        angegebenen Projekts und nur auf der MIND.set-Plattform verwendet
        werden. Einzelne Bilder dürfen zu Dokumentationszwecken in Berichten
        oder wissenschaftlichen Publikationen (z.B. Konferenzposter) mit
        entsprechender Quellenangabe verwendet werden:
        <br />
        <br />
        <Typography px={4}>
          Veit, Susanne; Essien, Iniobong (2022): The DeZIM Picture Database:
          Faces. Version:
          <br />
          1.2.0. Berlin: Deutsches Zentrum für Integrations- und
          Migrationsforschung (DeZIM).
          <br />
          Image. Faces:{' '}
          <a href="https://doi.org/10.34882/dezim.dpd-fac.f.1.2.0" target={'_blank'}>
            https://doi.org/10.34882/dezim.dpd-fac.f.1.2.0
          </a>
          <br />
          <br />
          Veit, Susanne; Essien, Iniobong (2022): The DeZIM Picture Database:
          Full Body Images. Version: 1.1.0.
          <br />
          Berlin: Deutsches Zentrum für Integrations- und Migrationsforschung
          (DeZIM). Image. Full Body Images:{' '}
          <a href="https://doi.org/10.34882/dezim.dpd-fbi.f.1.1.0" target={'_blank'}>
            https://doi.org/10.34882/dezim.dpd-fbi.f.1.1.0
          </a>
          <br />
          <br />
          Veit, Susanne; Essien, Iniobong (2022): The DeZIM Picture Database:
          Public Places. Version: 1.1.0. Berlin: Deutsches Zentrum für
          Integrations- und Migrationsforschung (DeZIM). Image. Public Places:{' '}
          <a href="https://doi.org/10.34882/dezim.dpd-pp.f.1.1.0" target={'_blank'}>
            https://doi.org/10.34882/dezim.dpd-pp.f.1.1.0
          </a>
          <br />
          <br />
        </Typography>
        Die Verwendung einzelner Bilder in wissenschaftlichen Berichten oder
        Publikationen ist auf das notwendige Minimum zu beschränken und §2 2.1
        muss berücksichtigt werden. Eine darüberhinausgehende Weitergabe an
        Dritte, das Remixen, Verändern oder Weiterverbreiten von Bildern oder
        anderen Inhalten aus dem Medienpool ist unabhängig von Zweck und Format
        untersagt. Die Nutzung der Inhalte für kommerzielle Zwecke ist nicht
        gestattet.
        <br />
        <br />
        (3) Ändert sich der Inhalt des Forschungsvorhabens, so ist zwischen den
        Parteien eine neue Datennutzungsvereinbarung zu schließen. In diesem
        Fall endet die Wirksamkeit dieser Vereinbarung, ohne dass es einer
        Kündigung bedarf.
        <br />
        <br />
        <b>§ 3 Beginn und Dauer der (Rahmen-)Nutzungsvereinbarung</b>
        <br />
        (1) Die Vereinbarung beginnt mit der erfolgreichen Anmeldung und dem
        Datum der Genehmigung dieser Datennutzungsvereinbarung durch beide
        Parteien und endet mit dem Ende des Forschungsvorhabens gemäß § 2, ohne
        dass es einer Kündigung bedarf.
        <br />
        <br />
        (2) Um die MIND.set-Plattform zu nutzen, müssen sich die
        Wissenschaftler*innen unter{' '}
        <a href="https://mindset.dezim-institut.de/register" target={'_blank'}>
          https://mindset.dezim-institut.de/register
        </a>{' '}
        mit ihrer institutionellen E-Mail-Adresse registrieren. Bei der
        Registrierung müssen sie Angaben zu ihrem Namen, ihrer Einrichtung und
        ihrem Forschungsprojekt machen, siehe § 2 (1).{' '}
        <i>
          Außerdem müssen sie der Teilnehmendeninformation und Datenschutz (TID)
          für die Nutzung der MIND.set-Plattform zustimmen.
        </i>
        <br />
        <br />
        Die Administrator*innen des MIND.set Teams überprüfen manuell jeden
        Registrierungsantrag auf der Plattform und genehmigen oder verweigern
        ihn. Genehmigte registrierte Nutzende erhalten eine
        Benachrichtigungs-E-Mail mit einem passwortgeschützten Zugang zur
        MIND.set-Plattform und ihren Anmeldedaten, die ein einmaliges Passwort
        und ihren Benutzer*innen Namen (institutionelle E-Mail-Adresse)
        enthalten. Sobald die Nutzenden zum ersten Mal auf die Plattform
        zugreifen und das Passwort aktualisieren, gilt die Registrierung als
        abgeschlossen, und die*der Nutzende geht gleichzeitig die Vereinbarung
        zu den Allgemeine Bedingungen und Konditionen für die Nutzung der
        MIND.set-Plattform ein.
        <br />
        <br />
        (3) Das DeZIM behält sich das Recht vor, die Bearbeitungs- und
        Nutzungsrechte der Nutzenden jederzeit zu widerrufen oder
        zurückzunehmen.
        <br />
        <br />
        (4) Die Bearbeitungs- und Nutzungsrechte der Nutzenden enden unter den
        folgenden Bedingungen:
        <br />
        <br />
        <ul>
          <li>
            Bei Beendigung des Forschungsprojekts oder beim Ausscheiden der
            Nutzenden aus dem Projekt oder der Einrichtung, die Gegenstand der
            Vereinbarung ist.
          </li>
          <li>
            Im Falle der Auflösung, des Erwerbs oder der Neugründung des an der
            Vereinbarung beteiligten Instituts.
          </li>
        </ul>
        <br />
        <br />
        <b>§ 4 Rechte und Pflichten der Nutzenden</b>
        <br />
        <br />
        (1) Das DeZIM stellt den Nutzenden die MIND.set-Plattform und die
        Dienste über das Internet zur Verfügung. Die MIND.set-Plattform wird auf
        Servern gehostet, die sich in einem vom DeZIM und/oder dem technischen
        Dienstleister genutzten Rechenzentrum befinden. Die Nutzenden erhalten
        unentgeltlich das nicht ausschließliche, nicht übertragbare und nicht
        unterlizenzierbare Recht, für die Dauer dieser Vereinbarung mit einem
        Browser und einem Internetanschluss auf die MIND.set-Plattform
        zuzugreifen und sie bestimmungsgemäß zu nutzen. Dies schließt das Recht
        ein, Programmcodes (z.B. JavaScript) in dem dafür erforderlichen Umfang
        auf dem Rechner der Nutzenden zwischenzuspeichern (z.B. im
        Arbeitsspeicher oder Browser-Cache) und dort auszuführen. Die
        eingeräumten Nutzungsrechte umfassen keine Rechte am Quellcode. Nach
        Ablauf der Vereinbarungslaufzeit hat der Nutzende keinen Zugriff mehr
        auf die Inhalte der MIND.set-Plattform oder auf die von der
        MIND.set-Plattform erzeugten und gespeicherten Daten. Es liegt in der
        Verantwortung der Nutzenden, die Daten vor Ablauf der
        Vereinbarungslaufzeit zu exportieren und für die weitere Nutzung zu
        speichern. Das DeZIM behält sich das Recht vor, die vom Nutzenden auf
        der MIND.set-Plattform gespeicherten Daten, einschließlich der
        eingestellten Inhalte, spätestens nach Ablauf der Vereinbarung zu
        löschen. Das DeZIM ist jedoch berechtigt, personenbezogene Daten der
        Nutzenden (Name, E-Mail, Institution, Forschungsprojekt, Datum der
        Registrierung) zu gesetzlichen Nachweispflichten und zur Erfüllung von
        Aufbewahrungspflichten gegenüber den Nutzenden datenschutzkonform
        aufzubewahren. Darüber hinaus behält sich das DeZIM das Recht vor,
        eingestellte Inhalte und von der MIND.set-Plattform generierte (anonyme)
        Daten längerfristig aufzubewahren und mittels einer Rechteeinräumung
        öffentlich zugänglich zu machen, um diese Daten und Inhalte der
        Forschungsgemeinschaft zur Verfügung zu stellen.
        <br />
        <br />
        (2) Den Nutzenden ist es untersagt, die Dienste und Funktionen der
        MIND.set-Plattform missbräuchlich zu nutzen. Sie sind insbesondere dazu
        verpflichtet:
        <br />
        <br />
        (2.1) Sicherzustellen, dass alle bei der Registrierung gemachten Angaben
        korrekt und vollständig sind. Diese Angaben müssen stets aktuell
        gehalten werden. Es ist insbesondere – aber nicht ausschließlich –
        untersagt, falsche Angaben zur eigenen Identität zu machen.
        <br />
        <br />
        (2.2) Die Dienste und Funktionen der MIND.set-Plattform nur in
        Übereinstimmung mit den geltenden nationalen und internationalen
        Gesetzen sowie sonstigen Vorschriften zu nutzen. Insbesondere dürfen
        keine Rechte Dritter, wie z. B. Persönlichkeitsrechte, Urheberrechte,
        Marken- und Namensrechte oder sonstige gewerbliche Schutzrechte,
        verletzt werden.
        <br />
        <br />
        (2.3) Darauf zu achten, keine Informationen mit rechtswidrigem oder
        sittenwidrigem Inhalt einzustellen oder zu verlinken. Hierzu gehören
        insbesondere – aber nicht ausschließlich – Inhalte, die rassistisch
        sind, Gewalt verherrlichen oder verharmlosen, einschließlich
        Kriegsverherrlichung, sexuell anstößig oder pornografisch sind oder
        Kinder oder Jugendliche gefährden oder deren Wohl beeinträchtigen.
        <br />
        <br />
        (2.4) Sicherzustellen, dass alle Dateien (z. B. Bilder), die auf die
        MIND.set-Plattform hochgeladen werden, vorab mit einem aktuellen
        Prüfprogramm auf Malware untersucht werden. Es dürfen ausschließlich
        Dateien hochgeladen werden, die frei von solchen schädlichen Komponenten
        sind.
        <br />
        <br />
        (3) Soweit Nutzende auf der Plattform MIND.set und den Diensten
        Informationen und Angaben für Dritte einstellen, behält sich das DeZIM
        das Recht vor, vom Nutzende jederzeit den Nachweis der Berechtigung zum
        Handeln für den Dritten zu verlangen, und der Nutzende ist verpflichtet,
        diesem Verlangen unverzüglich nachzukommen. Kommt der Nutzende diesen
        Aufforderungen nicht unverzüglich nach, behält sich das DeZIM vor, den
        Zugang der Nutzenden ganz oder teilweise zu sperren, bis ein
        entsprechender Nachweis erbracht ist; die Möglichkeit der Kündigung nach
        Ziffer 2 (oben) bleibt hiervon unberührt.
        <br />
        <br />
        <b>
          § 5 Hochladen von Daten in den MIND.set-Medienpool durch den Nutzenden
        </b>
        <br />
        <br />
        (1) Soweit der Nutzende urheberrechtlich oder anderweitig geschützte
        Inhalte, insbesondere - aber nicht nur - Texte (insbesondere Fragen aus
        Fragebögen), Audio- und Videomaterial, Bilddateien, Logos,
        Firmenzeichen, Marken, etc. auf die MIND.set-Plattform hochlädt und/oder
        einstellt, erklärt und gewährleistet der Nutzende zugleich, dass sie*er
        dazu berechtigt ist, soweit sie*er nicht selbst Urheber oder originär
        Nutzungsberechtigter ist. Werden durch die vom Nutzende hochgeladenen
        und/oder eingestellten Inhalte die Persönlichkeitsrechte von
        abgebildeten oder in Audio- und Videoaufnahmen festgehaltenen Personen
        berührt, erklärt und gewährleistet der Nutzer, dass sie*er eine wirksame
        Einwilligung der abgebildeten oder festgehaltenen Personen eingeholt
        hat.
        <br />
        <br />
        (2) Mit dem Hochladen von Inhalten auf die MIND.set-Plattform gemäß
        Ziffer 4.1 räumt der Nutzende dem DeZIM das unentgeltliche,
        unwiderrufliche und zeitlich unbeschränkte Recht ein, diese Inhalte in
        jeglicher Form und in jeglichem Medium innerhalb der MIND.set-Plattform
        zum Abruf durch Dritte zu vervielfältigen, zu verbreiten, öffentlich
        zugänglich zu machen, zu bearbeiten und zu nutzen, sofern der Nutzende
        zitiert wird und keine Urheberrechte Dritter verletzt werden.
        <br />
        <br />
        (3) Das DeZIM haftet nicht für die von Nutzenden oder sonstigen Dritten
        auf die MIND.set-Plattform und die Dienste hochgeladenen und
        eingestellten Daten und Informationen, weder im Hinblick auf deren
        Vollständigkeit, Richtigkeit oder Aktualität, noch dafür, dass sie frei
        von Rechten Dritter sind oder dass der Nutzende oder Dritte durch das
        Hochladen oder Einstellen von Daten auf die MIND.set-Plattform und die
        Dienste rechtmäßig handeln.
        <br />
        <br />
        <b>§ 6 Datenschutz und Sicherheit</b>
        <br />
        <br />
        Bei der Verarbeitung von personenbezogenen Daten im Rahmen der Nutzung
        des Vereinbarungsgegenstands verpflichtet sich der Nutzende, die
        Bestimmungen der DSGVO, des Bundesdatenschutzgesetzes (BDSG) und ggf.
        anwendbarer länderspezifischer Datenschutzgesetze und anderer
        einschlägiger Gesetze einzuhalten. Dies betrifft personenbezogene Daten
        sowohl der Teilnehmenden an Tests im Rahmen von MIND.set als auch der
        auf Fotos abgebildeten Personen aus der Fotodatenbank, die Teil von
        MIND.set ist.
        <br />
        <br />
        (1) Der Nutzende hat jede Handlung zu unterlassen, die auf die
        Identifizierung von Testteilnehmenden oder Personen in der
        DeZIM-Fotodatenbank abzielt oder dazu geeignet ist. Der Einsatz von
        Bilderkennungssoftware oder künstlicher Intelligenz zu
        Identifikationszwecken ist ausdrücklich untersagt.
        <br />
        <br />
        (2) Werden Testteilnehmende oder Personen auf den Fotos durch den
        Nutzenden identifiziert, auch wenn dies nicht auf eine bestimmte
        Handlung zurückzuführen ist, hat der Nutzende das DeZIM unverzüglich zu
        informieren (in Textform per E-Mail an{' '}
        <a href="mailto:mindset@dezim-institut.de" target={'_blank'}>
          mindset@dezim-institut.de
        </a>{' '}
        und{' '}
        <a href="mailto:datenschutz@dezim-institut.de" target={'_blank'}>
          datenschutz@dezim-institut.de
        </a>
        ). Eine Weitergabe dieser Tatsache an Dritte ist ausnahmslos zu
        unterlassen.
        <br />
        <br />
        (3) Der Nutzende verpflichtet sich, den Schutz und die Sicherheit der
        personenbezogenen Daten, die bei der Nutzung des
        Vereinbarungsgegenstandes verarbeitet werden, durch den Einsatz
        geeigneter, dem Stand der Technik entsprechender technischer und
        organisatorischer Maßnahmen zu gewährleisten. Insbesondere ist durch dem
        Schutzbedarf der Betroffenen entsprechende Speichermedien,
        Authentifizierungsregeln und Verschlüsselungstechniken sicherzustellen,
        dass die auf MIND.set verarbeiteten personenbezogenen Daten angemessen
        und ausreichend vor Verlust, unberechtigtem Zugriff und unberechtigter
        Veränderung, Offenlegung und Weiterverarbeitung geschützt sind.
        <sup>1</sup>
        <br />
        <br />
        (4) Der*die Nutzer*in ist verpflichtet, an der Wahrung der Rechte der
        betroffenen Personen mitzuwirken, insbesondere des Rechts auf
        Berichtigung, Löschung oder Einschränkung der Verarbeitung (Artikel
        16-18 DSGVO), des Rechts auf Widerruf der Einwilligung (Artikel 7 Abs. 3
        DSGVO) und des Widerspruchsrechts nach Artikel 21 DSGVO. Er*sie teilt
        sowohl den Testteilnehmenden als auch dem DeZIM eine
        Kontakt-E-Mail-Adresse mit, unter der er*sie bei entsprechenden Anfragen
        von betroffenen Personen erreicht werden kann. Er*sie verpflichtet sich,
        das DeZIM unverzüglich zu informieren, wenn sich seine*ihre Kontaktdaten
        ändern.
        <br />
        <br />
        (5) Die Nutzung von Auftragsverarbeitern (z.B. externen Dienstleistern)
        zur Verarbeitung personenbezogener Daten im Rahmen des
        Vertragsgegenstands (MIND.set-Plattform) ist nicht gestattet.
        <br />
        <br />
        (6) Im Falle einer Verletzung des Schutzes personenbezogener Daten hat
        der Nutzende das DeZIM unverzüglich zu informieren (in Textform per
        E-Mail an{' '}
        <a href="mailto:mindset@dezim-institut.de">
          mindset@dezim-institut.de
        </a>{' '}
        und{' '}
        <a href="mailto:datenschutz@dezim-institut.de">
          datenschutz@dezim-institut.de
        </a>
        ).
        <br />
        <br />
        (7) Wenn eine Form der Verarbeitung, insbesondere beim Einsatz neuer
        Technologien, aufgrund der Art, des Umfangs, der Umstände und der Zwecke
        der Verarbeitung voraussichtlich ein hohes Risiko für die Rechte und
        Freiheiten der auf den Fotos abgebildeten Personen zur Folge hat, hat
        der Nutzende vorab eine Abschätzung der Folgen der beabsichtigten
        Verarbeitungsvorgänge für den Schutz personenbezogener Daten vorzunehmen
        (Artikel 35 DSGVO). Das Ergebnis ist dem DeZIM in Textform per E-Mail an{' '}
        <a href="mailto:mindset@dezim-institut.de">
          mindset@dezim-institut.de
        </a>{' '}
        und{' '}
        <a href="mailto:datenschutz@dezim-institut.de">
          datenschutz@dezim-institut.de
        </a>{' '}
        mitzuteilen. Das DeZIM behält sich das Recht vor, das Ergebnis zu
        überprüfen und ggf. Widerspruch einzulegen.
        <br />
        <br />
        (8) Der Nutzende ist verpflichtet, die auf MIND.set erzeugten,
        personenbezogenen Daten einschließlich der Sicherungskopien, Backups,
        modifizierten Kopien, Auszugsdateien und Hilfsdateien (.JSON-Dateien der
        Tests) auf allen Datenträgern bei Erlöschen des Verarbeitungs- und
        Nutzungsrechts oder Beendigung des Vereinbarungsverhältnisses
        unverzüglich und unwiderruflich zu löschen oder zu vernichten. Absolut
        anonymisierte Daten können vom Nutzende für wissenschaftliche Zwecke
        aufbewahrt und im Sinne von Open Science und Open Data an die
        wissenschaftliche Gemeinschaft weitergegeben werden (z.B. über das Open
        Science Framework, OSF). Die Beendigung der Arbeiten ist dem DeZIM
        unverzüglich in Textform mitzuteilen.
        <br />
        <br />
        <b>
          § 7 Verfügbarkeit der MIND.set-Plattform und Entfernung von Malware
        </b>
        <br />
        <br />
        (1) Eine bestimmte Verfügbarkeit der Dienste und Funktionen der
        MIND.set-Plattform und der unentgeltlich zur Verfügung gestellten
        Dienste kann nicht garantiert werden. Der Nutzende behält sich
        insbesondere nicht das Recht vor, von ihm erstellte Online-Experimente
        oder Umfragen einer bestimmten (gleichzeitigen) Teilnehmendenzahl zur
        Verfügung zu stellen oder von ihm auf die MIND.set-Plattform
        hochgeladene oder dort eingegebene Daten herunterzuladen.
        <br />
        <br />
        (2) Das DeZIM behält sich das Recht vor, zu verhindern, dass Nutzende
        Daten, die nach Kenntnis des DeZIMs Malware enthalten, auf der
        MIND.set-Plattform und den Diensten speichern und abrufen. Das DeZIM
        wird die betroffenen Nutzende hierüber schnellstmöglich nach Entdeckung
        solcher Daten informieren. Sollten solche Daten die Integrität und/oder
        Nutzbarkeit der Dienste und Funktionen der MIND.set-Plattform und ihrer
        Dienste gefährden, kann das DeZIM diese Daten auch ohne vorherige
        Benachrichtigung der Nutzenden löschen, um (weiteren) Schaden
        abzuwenden.
        <br />
        <br />
        (3) Zur Aufrechterhaltung der allgemeinen Leistungsfähigkeit der
        MIND.set-Plattform behält sich das DeZIM das Recht vor, die
        (gleichzeitige) Anzahl der Teilnehmenden an vom Nutzende erstellten
        Online-Experimenten oder Umfragen technisch zu begrenzen.
        <br />
        <br />
        <b>§ 8 Veröffentlichungen</b>
        <br />
        <br />
        Der Nutzende verpflichtet sich, in Veröffentlichungen oder anderen
        Arbeiten (z.B. Dissertationen), in denen der Vereinbarungsgegenstand
        verwendet wird, auf die Referenzquelle zu verweisen und den
        entsprechenden DOI anzugeben.
        <br />
        <br />
        <b>§ 9 Vereinbarungsverstoß</b>
        <br />
        <br />
        (1) Verstößt der Nutzende gegen die Pflichten aus diesem Vertrag, so hat
        sie*er das DeZIM unverzüglich zu informieren. Verstöße in diesem Sinne
        sind beispielsweise:
        <br />
        <br />
        <ul>
          <li>
            Die Verarbeitung oder Nutzung des Vereinbarungsgegenstandes,
            einschließlich einzelner Bestandteile des Vereinbarungsgegenstandes,
            für andere Zwecke als das in § 2 dieser Vereinbarung genannte
            Forschungsvorhaben;
          </li>
          <li>
            Keine oder unzureichende Angabe von Datenquellen in
            Veröffentlichungen;
          </li>
          <li>
            Re-Identifizierung von Personen, die auf den Komponenten des
            Vereinbarungsgegenstandes abgebildet sind;
          </li>
          <li>
            Die Weitergabe des Vereinbarungsgegenstandes oder einzelner
            Bestandteile des Vereinbarungsgegenstandes an Dritte;
          </li>
          <li>
            Unbefugter Zugriff auf den Vereinbarungsgegenstand oder seine
            einzelnen Bestandteile, unabhängig von der Ursache des unbefugten
            Zugriffs;
          </li>
          <li>
            Nichteinhaltung der Anforderungen an die sichere
            Aufbewahrung/Aufbewahrung und Verarbeitung des
            Vereinbarungsgegenstandes;
          </li>
          <li>
            Die Offenlegung von persönlichen Zugangscodes und Passwörtern;
          </li>
        </ul>
        <br />
        <br />
        (2) Im Falle eines Verstoßes gegen eine der in Absatz 1 genannten
        Pflichten ergreift das DeZIM je nach den Umständen und der Schwere des
        Falles eine oder mehrere der folgenden Maßnahmen:
        <ul>
          <li>
            Der Nutzende hat die Bilddatenbank sowie alle im Rahmen der Nutzung
            von MIND.set generierten personenbezogenen Daten einschließlich
            aller Sicherungskopien, Auszüge und Hilfsdateien unverzüglich und
            unwiderruflich zu löschen; Anonyme Testdaten sind davon
            ausgeschlossen.
          </li>
          <li>
            Die im Ständigen Ausschuss Forschungsdateninfrastruktur (FDI) und im
            RatSWD zusammengeschlossenen Forschungsdatenzentren erhalten einen
            entsprechenden Hinweis auf den Verstoß;
          </li>
          <li>
            Der Nutzende wird vorübergehend oder dauerhaft vom Zugang zu den
            DeZIM-Diensten ausgeschlossen.
          </li>
        </ul>
        <br />
        <br />
        (3) Der Nutzende verpflichtet sich für den Fall einer vorsätzlichen oder
        grob fahrlässigen Verletzung von Vereinbarungspflichten zur Zahlung
        einer Vereinbarungsstrafe in Höhe von 100.000€ (Euro).
        <br />
        <br />
        <b>§ 10 Haftung</b>
        <br />
        <br />
        (1) Der Nutzende haftet dem DeZIM für alle Schäden, die durch eine nicht
        vereinbarte, unbefugte oder fehlerhafte Handhabung durch den Nutzenden
        im Rahmen des Zugriffs auf den überlassenen Vereinbarungsgegenstand
        entstehen und stellt das DeZIM von diesbezüglichen Haftungsansprüchen
        Dritter frei.
        <br />
        <br />
        (2) Das DeZIM haftet gegenüber dem Nutzende nicht für Verluste oder
        Schäden jeglicher Art im Zusammenhang mit dem Vereinbarungsgegenstand
        oder mit Schlussfolgerungen oder Empfehlungen, die in den damit
        verbundenen Informationen enthalten sein können. Der Nutzende erkennt
        hiermit an, dass sie*er allein für die Folgen der Handlungen
        verantwortlich ist, die auf der Grundlage der erhaltenen Daten oder als
        Ergebnis ihrer Interpretation vorgenommen werden können.
        <br />
        <br />
        <b>§ 11 Änderungen der Vereinbarung</b>
        <br />
        <br />
        (1) Änderungen oder Ergänzungen dieser Vereinbarung bedürfen zu ihrer
        Wirksamkeit der Textform.
        <br />
        <br />
        (2) Sollten einzelne Bestimmungen dieser Vereinbarung, z.B. im Falle von
        Änderungen oder Ergänzungen gemäß Absatz 1, auch in der geänderten oder
        ergänzten Fassung, unwirksam sein oder werden, so bleibt die Wirksamkeit
        der übrigen, damit nicht zusammenhängenden Bestimmungen unberührt. In
        diesem Fall ist die unwirksame Bestimmung durch eine Regelung zu
        ersetzen, die dem wirtschaftlichen Zweck der unwirksamen Bestimmung im
        Wege der Vereinbarungsergänzung am nächsten kommt.
        <br />
        <br />
        (3) Bei Meinungsverschiedenheiten über Inhalt und Umfang des
        Nutzungsrechts entscheidet das DeZIM.
        <br />
        <br />
        (4) Es wird die Anwendung deutschen Rechts vereinbart. Ausschließlicher
        Gerichtsstand ist Berlin.
        <br />
        <br />
        <b>§ 12 Kosten</b>
        <br />
        <br />
        Die Nutzung der MIND.set-Plattform ist grundsätzlich kostenlos. Kosten,
        die dem DeZIM durch besondere Anforderungen der Nutzenden entstehen, wie
        z.B. die Verwendung eigener Software oder der Import von Fremddaten,
        können gesondert in Rechnung gestellt werden.
        <br />
        <br />
        <hr />
        <br />
        <sup>1</sup>
        <Typography variant="caption">
          Weitere Informationen und Tipps zum sicheren Umgang mit der Datenbank finden Sie auf diesem
          Online-Informationsblatt: <a
          href="https://www.gesis.org/fileadmin/upload/dienstleistung/daten/secure_data_center/GESIS_Merkblatt_zum_sicheren_Datenumgang.pdf"
          target="_blank">https://www.gesis.org/fileadmin/upload/dienstleistung/daten/secure_data_center/GESIS_Merkblatt_zum_sicheren_Datenumgang.pdf</a>
        </Typography>
      </Typography>
    </>
  );
}

export function UsagePolicyEnglish({
                                     currentData
                                   }: {
  currentData: Partial<RegisterUserMutationVariables>;
}) {
  return (
    <>
      <Typography align="center">
        <b>Agreement on General Terms and Conditions (GTC) </b>
        <br />
        <b> for the use of the MIND.set platform </b>
        <br /> <br />
        Between the
        <br />
        <br />
        German Center for Integration and Migration Research (DeZIM) e.V.
        <br />
        Mauerstraße 76, 10117 Berlin, represented by the Executive Board
        <br />- Hereinafter referred to as <b>"DeZIM"</b> -<br />
        <br />
        and
        <br />
        <br />
        {currentData.name}
        <br />
        <br />- Hereinafter referred to as "users" -<br />
        <br />
        Hereinafter jointly referred to as the Parties, the following agreement
        is concluded on the granting of rights of use and the processing of
        DeZIM microdata:
      </Typography>
      <br />
      <Typography>
        <b>
          § 1 Subject matter of the agreement and scope of application for the
          use of the MIND.set platform
        </b>
        <br />
        <br />
        (1) These GTC serve to define the general framework conditions for the
        legal relationship between the German Center for Integration and
        Migration Research DeZIM e.V. ("DeZIM") and the registered users
        ("users") with regard to the free provision of the online-based MIND.set
        platform ("MIND.set platform") and form the basis for the use of the
        tools and services offered on the MIND.set platform to which access is
        granted ("services").
        <br />
        <br />
        DeZIM grants registered users the right to use the MIND.set platform
        exclusively in accordance with the following agreement.
        <br />
        <br />
        (2) Registration on and use of the MIND.set platform is subject to these
        General Terms and Conditions.
        <br />
        <br />
        (3) These General Terms and Conditions can be accessed at any time on
        the MIND.set platform.
        <br />
        <br />
        (4) DeZIM reserves the right to amend these to an extent that is
        reasonable for the user. The latest version shall apply, unless the user
        objects to the validity of the new provisions within six (6) weeks after
        DeZIM has expressly drawn his attention to this and the consequences of
        his silence.
        <br />
        <br />
        (5) Insofar as DeZIM provides services free of charge, these are not
        contractually guaranteed and can be changed or discontinued at any time
        and without prior notice. DeZIM therefore also reserves the right to
        make changes to the MIND.set platform or to offer different functions at
        any time, unless the change or deviation is unreasonable for DeZIM and
        the user, taking into account their interests.
        <br />
        <br />
        <b>§ 2 License for scientific purposes </b>
        <br />
        <br />
        (1) The MIND.set platform may only be processed or used for the user's
        own scientific research in the context of the following research
        project.
        <br />
        <br />
        Title of the research project: {currentData.researchProjectName}
        <br />
        <br />
        Start of the project: {formatDateOnly(currentData.projectStart)}
        <br />
        <br />
        End of the project: {formatDateOnly(currentData.projectEnd)}
        <br />
        <br />
        Description of the research project (brief description of the research
        objective or the central questions of the project):
        <br />
        <pre style={{ marginLeft: '0.5em' }}>{currentData.researchGoal}</pre>
        <br />
        Description of the methodological approach (research methods):
        <br />
        <pre style={{ marginLeft: '0.5em' }}>
          {currentData.methodDescription}
        </pre>
        <br />
        Qualification project, if applicable:
        {currentData.isQualificationProject ? 'Ja' : 'Nein'}
        <br />
        <br />
        (2) Restrictions on the use of the Services:
        <br />
        <br />
        (2.1) Non-discriminatory principles in MIND.set tests and on the
        platform
        <br />
        <br />
        Tests and content on the MIND.set platform must comply with the
        principles of non-discrimination both linguistically and conceptually.
        Article 14 of the <b>European Convention on Human Rights (ECHR)</b>,
        which prohibits discrimination, applies:
        <br />
        <br />
        <i>
          {'"'}The enjoyment of the rights and freedoms set forth in this
          Convention shall be secured without discrimination on any ground such
          as sex, race, color, language, religion, political or other opinion,
          national or social origin, association with a national minority,
          property, birth or other status.{'"'}
        </i>
        <br />
        <br />
        In addition, all materials must use bias-free language and images that
        ensure inclusion and respect for all people while avoiding prejudiced
        beliefs or demeaning attitudes.
        <br />
        <br />
        Unnecessary and irrelevant stereotyping in relation to age, disability,
        gender, racial and ethnic identity, religion, sexual orientation,
        socio-economic status and other intersectional characteristics must be
        avoided. Users are responsible for ensuring that their use of the
        platform's resources complies with these standards.
        <br />
        <br />
        (2.2) Use of the MIND.set platform and tests
        <br />
        <br />
        The MIND.set platform and its tests may only be used for scientific
        research, experiments and studies within the scope of the specified
        research project. The tests may be presented to the study participants,
        and individual images or screenshots may be used in documentation,
        reports or scientific publications (e.g. conference posters) with the
        correct source citation from the current MIND.set{' '}
        <a href={'/impressum'} target={'_blank'}>
          imprint
        </a>{' '}
        with the current software version:
        <br />
        <br />
        Sharing MIND.set accounts, distributing tests or copying platform
        content to external parties in any form is not permitted, regardless of
        purpose or format. The use of the platform or its tests for commercial
        purposes is strictly prohibited.
        <br />
        <br />
        (2.3) Use of the MIND.set media pool and the DeZIM photo databases
        <br />
        <br />
        The MIND.set media pool contains the DeZIM photo databases. Photos from
        the DeZIM photo databases may also be used exclusively for scientific
        research, experiments and studies within the scope of the specified
        project and only on the MIND.set platform. Individual images may be used
        for documentation purposes in reports or scientific publications (e.g.
        conference posters) with appropriate acknowledgement of the source:
        <br />
        <br />
        <Typography px={4}>
          Veit, Susanne; Essien, Iniobong (2022): The DeZIM Picture Database:
          Faces. Version:
          <br />
          1.2.0. Berlin: Deutsches Zentrum für Integrations- und
          Migrationsforschung (DeZIM).
          <br />
          Image. Faces:{' '}
          <a href="https://doi.org/10.34882/dezim.dpd-fac.f.1.2.0" target={'_blank'}>
            https://doi.org/10.34882/dezim.dpd-fac.f.1.2.0
          </a>
          <br />
          <br />
          Veit, Susanne; Essien, Iniobong (2022): The DeZIM Picture Database:
          Full Body Images. Version: 1.1.0.
          <br />
          Berlin: Deutsches Zentrum für Integrations- und Migrationsforschung
          (DeZIM). Image. Full Body Images:{' '}
          <a href="https://doi.org/10.34882/dezim.dpd-fbi.f.1.1.0" target={'_blank'}>
            https://doi.org/10.34882/dezim.dpd-fbi.f.1.1.0
          </a>
          <br />
          <br />
          Veit, Susanne; Essien, Iniobong (2022): The DeZIM Picture Database:
          Public Places. Version: 1.1.0. Berlin: Deutsches Zentrum für
          Integrations- und Migrationsforschung (DeZIM). Image. Public Places:{' '}
          <a href="https://doi.org/10.34882/dezim.dpd-pp.f.1.1.0" target={'_blank'}>
            https://doi.org/10.34882/dezim.dpd-pp.f.1.1.0
          </a>
          <br />
          <br />
        </Typography>
        The use of individual images in scientific reports or publications must
        be limited to the necessary minimum and §2 2.1 must be observed. Any
        further distribution to third parties, remixing, modification or
        redistribution of images or other content from the media pool is
        prohibited, regardless of purpose and format. The use of content for
        commercial purposes is not permitted.
        <br />
        <br />
        (3) If the content of the research project changes, a new data use
        agreement must be concluded between the parties. In this case, the
        effectiveness of this agreement shall end without the need for
        termination.
        <br />
        <br />
        <b>§ 3 Start and duration of the (framework) usage agreement</b>
        <br />
        (1) The agreement begins with the successful registration and the date
        of approval of this data use agreement by both parties and ends with the
        end of the research project in accordance with § 2, without the need for
        termination.
        <br />
        <br />
        In order to use the MIND.set platform, researchers must register at{' '}
        <a href="https://mindset.dezim-institut.de/register" target={'_blank'}>
          https://mindset.dezim-institut.de/register
        </a>{' '}
        with their institutional e-mail address. When registering, they must
        provide information about their name, their institution and their
        research project, see § 2 (1).{' '}
        <i>
          They must also agree to the Participant Information and Data
          Protection (PIDP) for the use of the MIND.set platform.
        </i>
        <br />
        <br />
        The MIND.set team administrators manually review each registration
        request on the platform and approve or deny it. Approved registered
        users will receive a notification email with a password-protected access
        to the MIND.set platform and their login details, which include a unique
        password and their user name (institutional email address). As soon as
        the user accesses the platform for the first time and updates the
        password, the registration is considered complete and the user
        simultaneously enters into the agreement on the General Terms and
        Conditions for the use of the MIND.set platform.
        <br />
        <br />
        (3) DeZIM reserves the right to revoke or withdraw the user's editing
        and usage rights at any time.
        <br />
        <br />
        (4) The processing and usage rights of the users end under the following
        conditions:
        <br />
        <br />
        <ul>
          <li>
            At the end of the research project or when the users leave the
            project or the institution that is the subject of the agreement.
          </li>
          <li>
            In the event of the dissolution, acquisition or reestablishment of
            the institution involved in the agreement.
          </li>
        </ul>
        <br />
        <br />
        <b>§ 4 Rights and obligations of users</b>
        <br />
        <br />
        (1) DeZIM makes the MIND.set platform and services available to users
        via the Internet. The MIND.set platform is hosted on servers located in
        a data center used by DeZIM and/or the technical service provider. Users
        are granted free of charge the non-exclusive, non-transferable and
        non-sublicensable right to access the MIND.set platform with a browser
        and an Internet connection for the duration of this agreement and to use
        it as intended. This includes the right to temporarily store program
        codes (e.g. JavaScript) to the extent necessary on the user's computer
        (e.g. in the working memory or browser cache) and to execute them there.
        The rights of use granted do not include any rights to the source code.
        After expiry of the term of the agreement, the user no longer has access
        to the contents of the MIND.set platform or to the data generated and
        stored by the MIND.set platform. It is the responsibility of the user to
        export the data before the end of the agreement term and to save it for
        further use. DeZIM reserves the right to delete the data stored by the
        user on the MIND.set platform, including the content posted, after the
        agreement expires at the latest. However, DeZIM is entitled to store
        personal data of users (name, e-mail, institution, research project,
        date of registration) for legal verification obligations and to fulfill
        of retention obligations towards users in compliance with data
        protection regulations. In addition, DeZIM reserves the right to store
        content posted and (anonymous) data generated by the MIND.set platform
        for a longer period and to make it publicly accessible by granting
        rights to make this data and content available to the research
        community.
        <br />
        <br />
        (2) Users are prohibited from misusing the services and functions of the
        MIND.set platform. In particular, they are obliged to:
        <br />
        <br />
        (2.1) Ensure that all information provided during registration is
        correct and complete. This information must be kept up to date at all
        times. In particular - but not exclusively - it is prohibited to provide
        false information about your own identity.
        <br />
        <br />
        (2.2) Use the services and functions of the MIND.set platform only in
        accordance with the applicable national and international laws and other
        regulations. In particular, no rights of third parties, such as personal
        rights, copyrights, trademark and name rights or other industrial
        property rights, may be infringed.
        <br />
        <br />
        (2.3) Ensure that no information with illegal or immoral content is
        posted or linked. This includes in particular - but not exclusively -
        content that is racist, glorifies or trivializes violence, including the
        glorification of war, is sexually offensive or pornographic or endangers
        children or young people or impairs their well-being.
        <br />
        <br />
        (2.4) Ensure that all files (e.g. images) uploaded to the MIND.set
        platform are scanned for malware in advance using an up-to-date scan
        program. Only files that are free of such malicious components may be
        uploaded.
        <br />
        <br />
        (3) If users post information and data for third parties on the MIND.set
        platform and the services, DeZIM reserves the right to request proof of
        authorization to act on behalf of the third party from the user at any
        time, and the user is obliged to comply with this request without delay.
        If the user does not comply with these requests immediately, DeZIM
        reserves the right to block the user's access in whole or in part until
        corresponding proof is provided; the possibility of termination in
        accordance with section 2 (above) remains unaffected by this.
        <br />
        <br />
        <b>§ 5 Uploading data to the MIND.set media pool by the user</b>
        <br />
        <br />
        (1) Insofar as the User uploads and/or posts content protected by
        copyright or otherwise, in particular - but not limited to - texts
        (especially questions from questionnaires), audio and video material,
        image files, logos, company logos, trademarks, etc. on the MIND.set
        platform, the User also declares and warrants that they are authorized
        to do so, unless they are the author or original authorized user. If the
        personal rights of persons depicted or recorded in audio and video
        recordings are affected by the content uploaded and/or posted by the
        user, the user declares and warrants that they have obtained the
        effective consent of the persons depicted or recorded.
        <br />
        <br />
        (2) By uploading content to the MIND.set platform in accordance with
        section 4.1, the user grants DeZIM the free, irrevocable and perpetual
        right to reproduce, distribute, make publicly accessible, edit and use
        this content in any form and in any medium within the MIND.set platform
        for retrieval by third parties, provided that the user is quoted and no
        third-party copyrights are infringed.
        <br />
        <br />
        (3) DeZIM is not liable for the data and information uploaded and posted
        by users or other third parties on the MIND.set platform and the
        services, neither with regard to their completeness, accuracy or
        timeliness, nor that they are free of third-party rights or that the
        user or third party is acting lawfully by uploading or posting data on
        the MIND.set platform and the services.
        <br />
        <br />
        <b>§ 6 Data protection and security </b>
        <br />
        <br />
        When processing personal data as part of the use of the subject matter
        of the Agreement, the User undertakes to comply with the provisions of
        the GDPR, the German Federal Data Protection Act (BDSG) and any
        applicable country-specific data protection laws and other relevant
        laws. This applies to personal data of both participants in tests as
        part of MIND.set and the persons depicted in photos from the photo
        database, which is part of MIND.set.
        <br />
        <br />
        (1) The user must refrain from any action aimed at or suitable for
        identifying test participants or persons in the DeZIM photo database.
        The use of image recognition software or artificial intelligence for
        identification purposes is expressly prohibited.
        <br />
        <br />
        (2) If test participants or persons in the photos are identified by the
        user, even if this is not due to a specific action, the user must inform
        DeZIM immediately (in text form by e-mail to{' '}
        <a href="mailto:mindset@dezim-institut.de">mindset@dezim-institut.de</a>
        and{' '}
        <a href="mailto:datenschutz@dezim-institut.de">
          datenschutz@dezim-institut.de
        </a>
        ). Disclosure of this fact to third parties is prohibited without
        exception.
        <br />
        <br />
        (3) The User undertakes to ensure the protection and security of the
        personal data processed when using the subject matter of the Agreement
        through the use of suitable, state-of-the-art technical and
        organizational measures. In particular, storage media, authentication
        rules and encryption techniques appropriate to the protection needs of
        the data subjects shall be used to ensure that the personal data
        processed on MIND.set is adequately and sufficiently protected against
        loss, unauthorized access and unauthorized modification, disclosure and
        further processing
        <sup>1</sup>
        <br />
        <br />
        (4) The user is obliged to cooperate in safeguarding the rights of the
        data subjects, in particular the right to rectification, erasure or
        restriction of processing (Articles 16-18 GDPR), the right to withdraw
        consent (Article 7 (3) GDPR) and the right to object pursuant to Article
        21 GDPR. They shall provide both the test participants and DeZIM with a
        contact e-mail address at which they can be reached in the event of
        corresponding inquiries from data subjects. They undertake to inform
        DeZIM immediately if their contact details change.
        <br />
        <br />
        (5) The use of processors (e.g. external service providers) for the
        processing of personal data within the scope of the subject matter of
        the contract (MIND.set platform) is not permitted.
        <br />
        <br />
        (6) In the event of a breach of the protection of personal data, the
        user must inform DeZIM immediately (in text form by e-mail to{' '}
        <a href="mailto:mindset@dezim-institut.de">
          mindset@dezim-institut.de
        </a>{' '}
        and{' '}
        <a href="mailto:datenschutz@dezim-institut.de">
          datenschutz@dezim-institut.de
        </a>
        ).
        <br />
        <br />
        (7) If a form of processing, in particular when using new technologies,
        is likely to result in a high risk to the rights and freedoms of the
        persons depicted in the photos due to the nature, scope, circumstances
        and purposes of the processing, the user must carry out an assessment of
        the consequences of the intended processing operations for the
        protection of personal data in advance (Article 35 GDPR). The result
        must be communicated to DeZIM in text form by e-mail to{' '}
        <a href="mailto:mindset@dezim-institut.de">
          mindset@dezim-institut.de
        </a>{' '}
        and{' '}
        <a href="mailto:datenschutz@dezim-institut.de">
          datenschutz@dezim-institut.de
        </a>
        . DeZIM reserves the right to review the result and to object if
        necessary.
        <br />
        <br />
        (8) The User is obliged to immediately and irrevocably delete or destroy
        the personal data generated on MIND.set, including backup copies,
        backups, modified copies, extract files and auxiliary files (.JSON files
        of the tests) on all data carriers upon expiry of the right of
        processing and use or termination of the contractual relationship.
        Absolutely anonymized data can be stored by the user for scientific
        purposes and passed on to the scientific community in the sense of Open
        Science and Open Data (e.g. via the Open Science Framework, OSF). DeZIM
        must be informed immediately in text form when the work is completed.
        <br />
        <br />
        <b>§ 7 Availability of the MIND.set platform and removal of malware</b>
        <br />
        <br />
        (1) A certain availability of the services and functions of the MIND.set
        platform and the services provided free of charge cannot be guaranteed.
        In particular, the User does not reserve the right to make online
        experiments or surveys created by them available to a specific
        (simultaneous) number of participants or to download data uploaded or
        entered on the MIND.set platform.
        <br />
        <br />
        (2) DeZIM reserves the right to prevent users from storing and accessing
        data on the MIND.set platform and services that DeZIM is aware contain
        malware. DeZIM will inform the affected users of this as soon as
        possible after discovering such data. Should such data jeopardize the
        integrity and/or usability of the services and functions of the MIND.set
        platform and its services, DeZIM may also delete this data without prior
        notification of the users in order to prevent (further) damage.
        <br />
        <br />
        (3) In order to maintain the general performance of the MIND.set
        platform, DeZIM reserves the right to technically limit the
        (simultaneous) number of participants in online experiments or surveys
        created by the user.
        <br />
        <br />
        <b>§ 8 Publications </b>
        <br />
        <br />
        The user undertakes to refer to the reference source in publications or
        other works (e.g. dissertations) in which the subject matter of the
        agreement is used and to indicate the corresponding DOI.
        <br />
        <br />
        <b>§ 9 Breach of agreement </b>
        <br />
        <br />
        (1) If the user breaches the obligations arising from this contract,
        they must inform DeZIM immediately. Violations in this sense are, for
        example:
        <br />
        <br />
        <ul>
          <li>
            The processing or use of the subject matter of the agreement,
            including individual components of the subject matter of the
            agreement, for purposes other than the research project specified in
            § 2 of this agreement;
          </li>
          <li>
            No or insufficient indication of data sources in publications;
          </li>
          <li>
            Re-identification of persons depicted on the components of the
            subject matter of the agreement;
          </li>
          <li>
            The transfer of the subject matter of the agreement or individual
            components of the subject matter of the agreement to third parties;
          </li>
          <li>
            Unauthorized access to the subject matter of the agreement or its
            individual components, regardless of the cause of the unauthorized
            access;
          </li>
          <li>
            Non-compliance with the requirements for the safekeeping/storage and
            processing of the subject matter of the agreement;
          </li>
          <li>The disclosure of personal access codes and passwords;</li>
        </ul>
        <br />
        <br />
        (2) In the event of a breach of one of the obligations referred to in §9
        (1), DeZIM shall take one or more of the following measures, depending
        on the circumstances and the seriousness of the case:
        <ul>
          <li>
            The user must immediately and irrevocably delete the image database,
            and all personal data generated while using MIND.set, including all
            backup copies, extracts and auxiliary files; anonymous test data is
            excluded from this.
          </li>
          <li>
            The research data centers that are members of the Standing Committee
            on Research Data Infrastructure (FDI) and the German Data Forum
            (RatSWD) will be notified of the infringement;
          </li>
          <li>
            The user is temporarily or permanently excluded from access to DeZIM
            services.
          </li>
        </ul>
        <br />
        <br />
        (3) The user undertakes to pay an agreement penalty of 100,000€ (Euro)
        in the event of an intentional or grossly negligent breach of agreement
        obligations.
        <br />
        <br />
        <b>§ 10 Liability</b>
        <br />
        <br />
        (1) The user shall be liable to DeZIM for all damage caused by
        unauthorized or incorrect handling by the user in the context of
        accessing the object of the agreement provided and shall indemnify DeZIM
        against any liability claims by third parties in this regard.
        <br />
        <br />
        (2) DeZIM shall not be liable to the user for any loss or damage of any
        kind in connection with the subject matter of the agreement or with any
        conclusions or recommendations that may be contained in the related
        information. The user hereby acknowledges that they are solely
        responsible for the consequences of any actions that may be taken on the
        basis of the data received or as a result of its interpretation.
        <br />
        <br />
        <b>§ 11 Amendments to the agreement </b>
        <br />
        <br />
        (1) Amendments or additions to this agreement must be made in text form
        to be effective.
        <br />
        <br />
        (2) Should individual provisions of this agreement be or become invalid,
        e.g. in the event of amendments or additions pursuant to paragraph 1,
        even in the amended or supplemented version, the validity of the
        remaining, unrelated provisions shall remain unaffected. In this case,
        the invalid provision shall be replaced by a provision that comes
        closest to the economic purpose of the invalid provision by way of
        supplementing the agreement.
        <br />
        <br />
        (3) In the event of differences of opinion regarding the content and
        scope of the right of use, DeZIM shall decide.
        <br />
        <br />
        (4) It is agreed that German law shall apply. The exclusive place of
        jurisdiction is Berlin.
        <br />
        <br />
        <b>§ 12 Costs </b>
        <br />
        <br />
        Use of the MIND.set platform is generally free of charge. Costs incurred
        by DeZIM due to special user requirements, such as the use of
        proprietary software or the import of third-party data, may be invoiced
        separately.
        <br />
        <br />
        <hr />
        <br />
        <sup>1</sup>
        <Typography variant="caption">
          Further information and tips on how to use the database securely can be found on this online information
          sheet: <a
          href="https://www.gesis.org/fileadmin/upload/dienstleistung/daten/secure_data_center/GESIS_Merkblatt_zum_sicheren_Datenumgang.pdf"
          target="_blank">https://www.gesis.org/fileadmin/upload/dienstleistung/daten/secure_data_center/GESIS_Merkblatt_zum_sicheren_Datenumgang.pdf</a>
        </Typography>
      </Typography>
    </>
  );
}
